export const retryCallback = (dispatch, requestName) => error => (error && dispatch({ type: `${requestName}_RETRY` }));
